import axios from "axios";

const BASE_URL = `/m-1/client`;

/**
 * Serwis do komunikacji z API - endpoint /client
 */
export const ClientService = {
  fetchStatus,
  updateStatus,
  fetchClientEntity,
  patchClientEnity,
  getClientAttachments,
  getRegisteredClientEvent,
  getWorkData,
  updateStatusFromCorrect,
  getFZdate,
  getClientVouchersAmount,
  getCalendarMeeting,
  cancelMeetingsForClient
};

function fetchStatus(clientId) {
  return axios.get(`${BASE_URL}/status/${clientId}`);
}

function updateStatus(clientId, data) {
  return axios.put(`${BASE_URL}/status/${clientId}`, data);
}

function fetchClientEntity(clientId) {
  return axios.get(`${BASE_URL}s/${clientId}`);
}

function patchClientEnity(clientId, data) {
  return axios.patch(`${BASE_URL}s/${clientId}`, data);
}

function getClientAttachments(clientId) {
  return axios.get(`${BASE_URL}s/${clientId}/attachments`);
}

function getRegisteredClientEvent(clientId) {
  return axios.get(`${BASE_URL}s/${clientId}/register-events`);
}

function getCalendarMeeting(clientId) {
  return axios.get(`${BASE_URL}s/${clientId}/meetings`);
}

function cancelMeetingsForClient(clientId,data) {
  return axios.post(
    `${BASE_URL}s/${clientId}/cancel-meetings`,
    data
  );
}

function getWorkData(clientId) {
  return axios.get(`${BASE_URL}/get-work-data`);
}

function updateStatusFromCorrect() {
  return axios.get(`${BASE_URL}/updateStatusFromToCorretctToRedyToVerify`);
}

function getFZdate(clientId) {
  return axios.get(`${BASE_URL}s/get-fz-date/${clientId}`);
}

function getClientVouchersAmount(clientId) {
  return axios.get(`${BASE_URL}s/${clientId}/vouchers`);
}